import React from 'react';

import ProteinConstants, {
  PRECISION_ISOELECTRIC_POINT,
  getMolecularWeightPrecision,
} from 'molbio/proteins/util/ProteinConstants';
import * as ProteinProperties from 'molbio/proteins/util/ProteinProperties';
import * as sequtil from 'molbio/SeqUtil';
import {proteinSelectionUIGlobalState} from 'toolbar/protein/ProteinUIGlobalState';

export interface ProteinStatusBarProps {
  proteinId: string;
  aminoAcids: string;
}

function ProteinStatusBar(props: ProteinStatusBarProps): JSX.Element {
  const [selection] = proteinSelectionUIGlobalState.useGlobalClientState(props.proteinId);

  function renderProteinSelectionStatus(): JSX.Element {
    const aminoAcids = sequtil.residueSlice(
      props.aminoAcids,
      selection.start,
      selection.end ?? undefined,
      false
    );
    const [start, end] = sequtil.modelRangeToDisplay(
      selection.start,
      selection.end,
      aminoAcids.length,
      ProteinConstants.DEFAULT_START_INDEX
    );
    if (selection.end != null) {
      return (
        <>
          <div className="statusbar-group" key="start">
            <div className="statusbar-label">Start</div>
            <div className="statusbar-field selectable">{start}</div>
          </div>
          <div className="statusbar-group" key="end">
            <div className="statusbar-label">End</div>
            <div className="statusbar-field selectable">{end}</div>
          </div>
          <div className="statusbar-group" key="length">
            <div className="statusbar-label">Length</div>
            <div className="statusbar-field selectable">{aminoAcids.length}</div>
          </div>
          <div className="statusbar-group" key="mw">
            <div className="statusbar-label">MW</div>
            <div className="statusbar-field selectable">
              {ProteinProperties.getMolecularWeight(aminoAcids).toFixed(getMolecularWeightPrecision())}
            </div>
          </div>
          <div className="statusbar-group" key="pI">
            <div className="statusbar-label">pI</div>
            <div className="statusbar-field selectable">
              {ProteinProperties.getIsoelectricPoint(aminoAcids).toFixed(PRECISION_ISOELECTRIC_POINT)}
            </div>
          </div>
        </>
      );
    }
    return (
      <div className="statusbar-group">
        <div className="statusbar-label">Insert</div>
        <div className="statusbar-field selectable">{start}</div>
      </div>
    );
  }

  return (
    <div>
      <div className="statusbar-section">
        <div className="statusbar-group">
          <div className="statusbar-label">Amino Acids</div>
          <div className="statusbar-field selectable">{props.aminoAcids.length}</div>
        </div>
      </div>
      <div className="statusbar-section">{renderProteinSelectionStatus()}</div>
    </div>
  );
}

export default ProteinStatusBar;
